module.exports = __webpack_public_path__ + "static/media/star-pattern.d4d9d27a.svg";